import React from 'react';
import styled from 'styled-components';
import Tippy from '@tippyjs/react/headless';
import Balancer from 'react-wrap-balancer';

const Tooltip = ({ children, content }) => {
  if (!content) {
    return children;
  }

  return (
    <Tippy
      placement="top"
      render={attrs => (
        <Container id="tooltip" role="tooltip" tabIndex="-1" {...attrs}>
          <Normalize>
            <Balancer>{content}</Balancer>
            {/* {content} */}
          </Normalize>
          <Arrow id="arrow" data-popper-arrow />
        </Container>
      )}
    >
      {children}
    </Tippy>
  );
};

const Normalize = styled.p`
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  line-height: 1.3rem;
`;

const Container = styled.div`
  background-color: white;
  opacity: 1;
  color: var(--textGrey);
  border: 1px solid var(--infoGrey);
  border-radius: 4px;
  padding: 8px 16px;
  max-width: 250px;
  min-width: 100px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 11px rgba(0, 0, 0, 0.1);
`;

// Style is in global styles
const Arrow = styled.div``;

export default Tooltip;
